export enum TrackingEvent {
  AddToCart = 'AddToCart',
  ViewContent = 'ViewContent',
  ViewProduct = 'ViewProduct',
  ViewLive = 'ViewLive',
}
